import React, { useContext } from "react";
import SelectionItem from "../../SelectionItem";
import ImgScrewFixation from "./images/screwFixation.png";
import ImgCementFixation from "./images/cementFixation.png";
import ImgMultiunutFixation from "./images/multiunutFixation.png";
import "./index.scss";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const ImplantationSelectFixation = ({
  selectStep,
  stepId
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    toggleBottomBarInfo
  } = useContext(StepContext);
  const types = [{
    key: "screwFixation",
    img: ImgScrewFixation,
    name: _t("Винтовая фиксация протеза к импланту"),
    description: _t("Применяется чаще всего при протезировании одного зуба на импланте или не больших протезах...")
  }, {
    key: "cementFixation",
    img: ImgCementFixation,
    name: _t("Цементная фиксация протеза к импланту"),
    description: _t("Применимо практически ко всем типам конструкций на имплантах...")
  }, {
    key: "multiunutFixation",
    img: ImgMultiunutFixation,
    name: _t("Фиксация на мульти-юнитах"),
    description: _t("Для сложных конструкций большей протяженности с непараллельной позицией имплантов...")
  }];

  function setStep(key) {
    // formula magic for current step and selectStep
    // Here we're getting some wtf with mutation
    let updatedData = {};

    if (dentalData.hasOwnProperty("tooth")) {
      updatedData = { ...dentalData,
        tooth: dentalData.tooth.map(el => {
          if (el.toothElementsActive.includes("implantPosition")) {
            switch (key) {
              case "screwFixation":
                return { ...el,
                  toothElementsActive: [...el.toothElementsActive, "plasticCrown", "screwFixationImplants"]
                };

              case "cementFixation":
                return { ...el,
                  toothElementsActive: [...el.toothElementsActive, "individualZirconiumAbutment", "plasticCrown"]
                };

              case "multiunutFixation":
                return { ...el,
                  toothElementsActive: [...el.toothElementsActive, "multiunitAbutment", "plasticCrown"]
                };

              default:
                return el;
            }
          }

          return el;
        })
      };
    }

    selectStep(key, updatedData);
  }

  function openBottomBar(type) {
    toggleBottomBarInfo(true, type);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "implantationSelectFixation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "implantationSelectFixation-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    itemKey: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name,
    outerDescription: el.description,
    aboutClick: () => {
      openBottomBar(el.key);
    }
  }))));
};

export default ImplantationSelectFixation;